import React from 'react';
import connect from 'Shared/connect';
import * as styles from './base.scss';
const SectionHeader = (prop) => (React.createElement("div", { className: styles.container },
    React.createElement("span", { className: styles.text }, prop.text)));
export default connect()(SectionHeader);
